<template>
  <div v-if="loading" class="text-center mt-5 font-2xl text-muted">
    <i class="fal fa-spinner fa-spin" /> Customer Field Data Loading...
  </div>

  <div v-else class="animated fadeIn">
    <basic-heading title="Edit Customer Field" class="mb-3" />

    <permission-alert-gate :permissions="['edit customer field']">
      <template #gated-content>
        <CustomerFieldForm
          :customer_field="customer_field"
          @submit="submit"
        />
      </template>
    </permission-alert-gate>
  </div>
</template>

<script>
import Vue from 'vue'
import VueNotifications from 'vue-notifications'
import BasicHeading from '@/components/shared/BasicHeading'
import PermissionAlertGate from '@/components/permission/PermissionAlertGate'
import { customerFieldNotifications } from '@/shared/notifications'
import { notificationOptions } from '@/shared/toast-notification-options'
import { getModel } from '@/shared/fetch-utils'
import { CrmRepositoryFactory } from '@/repositories/crm/CrmRepositoryFactory'
import CustomerFieldForm from '@/components/crm/customerfield/form/CustomerFieldForm'

const CustomerFieldsRepository = CrmRepositoryFactory.get('customerFields')

Vue.use(VueNotifications, notificationOptions)

export default {
  name: "CustomerFieldEdit",
  components: {
    BasicHeading,
    PermissionAlertGate,
    CustomerFieldForm
  },
  data () {
    return {
      loading: true,
      customer_id: this.$route.params.customer_id,
      customer_field_id: this.$route.params.customer_field_id || null,
      customer_field: null
    }
  },
  async created () {
    this.loading = true

    this.customer_field = await getModel({
      model_type: 'customer_field',
      id: this.customer_field_id,
      message: this.$bvToast
    })

    this.customer_field ? (this.loading = false) : this.$router.back()
  },
  methods: {
    async submit (form_data) {
      try {
        const { data } = await CustomerFieldsRepository.update(this.customer_field_id, {
          customer_id: this.customer_id,
          ...form_data
        })

        this.addSuccess()
        this.$router.push(`/customer/${data.customer_id}`)
      } catch ({ response }) {
        const { status, data } = response

        this.$bvToast.toast(`Code: ${status}. ${data.error}`, {
          title: 'Server Error.',
          variant: 'danger',
        })
      }
    }
  },
  notifications: customerFieldNotifications,
}
</script>
